/**
 * Iter 187 — AbandonedCartCapture: drop-in email field for storefront checkouts.
 * ============================================================================
 *
 * ONE-LINE INTEGRATION for any checkout page:
 *
 *   <AbandonedCartCapture />
 *
 * The component:
 *   • Renders a labelled email input
 *   • Persists to CartContext.customerEmail (localStorage-backed)
 *   • The CartContext auto-fires POST /api/public/cart-abandoned 2s
 *     after the email is entered (debounced) → cart-recovery cron
 *     then emails the shopper 1h/24h/48h later
 *   • Fires nothing if the cart is empty
 *
 * If the checkout is on a custom domain, the storefront `hostname` is
 * used as the subdomain (backend looks up by `builder_sites.subdomain`).
 * On the platform preview, the URL must include `/site/<subdomain>/...`.
 */
import React from 'react';
import { useCart } from '@/context/CartContext';
import { Mail } from 'lucide-react';

export default function AbandonedCartCapture({ className = '', label = 'Email', placeholder = 'you@example.com', testid = 'checkout-email' }) {
  const { customerEmail, setCustomerEmail } = useCart();
  return (
    <label className={`block ${className}`} data-testid={`${testid}-wrapper`}>
      <span className="block text-xs uppercase tracking-[0.18em] font-bold text-white/70 mb-1.5 flex items-center gap-1.5">
        <Mail size={11} /> {label}
      </span>
      <input
        type="email"
        value={customerEmail || ''}
        onChange={(e) => setCustomerEmail(e.target.value)}
        placeholder={placeholder}
        className="w-full px-3 py-2.5 rounded-lg bg-white/5 border border-white/15 text-white placeholder-white/30 focus:border-[#A78BFA]/50 outline-none"
        data-testid={testid}
        autoComplete="email"
      />
      <span className="block text-[10px] text-white/40 mt-1">
        We&#39;ll send order confirmations here — and remind you if you forget to check out.
      </span>
    </label>
  );
}
